import React from 'react';
import DatahubAPI from '../../../api/DatahubAPI';
import CustomAutocomplete from '../../../components/Common/MUICustomAutocomplete';

interface ICountryRiskOptions {
  formValues: any;
  setFormValues: any;
  selectedIndex: any;
  watchlistPrimaryOpts: any;
  riskAgencyOpts: any;
  setRiskAgencyOpts: any;
  riskListOpts: any;
  setRiskListOpts: any;
  toClear: any;
}

const CountryRiskOptions: React.FC<ICountryRiskOptions> = ({
  formValues,
  setFormValues,
  selectedIndex,
  watchlistPrimaryOpts,
  riskAgencyOpts,
  setRiskAgencyOpts,
  riskListOpts,
  setRiskListOpts,
  toClear,
}) => {
  const handleSourceCountrySelect = async(e: any) => {
    const obj: any = {
      ...formValues,
      sourceCountry: e,
      riskGovtAgency: [],
      riskListName: [],
    };
    setFormValues(obj);
    if (obj && obj.sourceCountry.length !== 0) {
      setRiskAgencyOpts({ isLoading: true, data: {} });
      setRiskListOpts({ isLoading: true, data: {} });

      const res = await DatahubAPI.watchlist({
        indexName: selectedIndex,
        sourceCountry: obj.sourceCountry,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            addedBuckets.push(bucket.govtAgencyAgg.buckets);
          },
        );
      }
      setRiskAgencyOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleRiskAgencySelect = async(e: any) => {
    const obj: any = {
      ...formValues,
      riskGovtAgency: e,
      riskListName: [],
    };
    setFormValues(obj);
    if (obj && obj.sourceCountry.length !== 0) {
      setRiskListOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.watchlist({
        indexName: selectedIndex,
        riskGovtAgency: obj.riskGovtAgency,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            bucket.govtAgencyAgg.buckets.map((secondBucket: any) => {
              addedBuckets.push(secondBucket.listNameAgg.buckets);
            });
          },
        );
      }
      setRiskListOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleRiskListName = async(e: any) => {
    setFormValues({ ...formValues, riskListName: e });
  };

  return (
    <div className='wl-dropdown-container'>
      {!watchlistPrimaryOpts.isLoading && (
        <CustomAutocomplete
          options={watchlistPrimaryOpts.data.countryAgg.buckets}
          placeholder='Source Country'
          onChange={handleSourceCountrySelect}
          toClear={toClear}
        />
      )}
      <CustomAutocomplete
        options={!riskAgencyOpts.isLoading ? riskAgencyOpts.data : []}
        placeholder='Agency'
        onChange={handleRiskAgencySelect}
        toClear={toClear}
      />
      <CustomAutocomplete
        options={!riskListOpts.isLoading ? riskListOpts.data : []}
        placeholder='List Name'
        onChange={handleRiskListName}
        toClear={toClear}
      />
    </div>
  );
};

export default CountryRiskOptions;
